import React, { useEffect, useState } from 'react';
import { useContextSelector } from 'use-context-selector';

import HeadTitle from '../../components/HeadTitle';

import { RouterContext } from '../../contexts/RouterContext';
import { PAGES } from '../../Router/pages';

import * as S from './styles';
import { PatientContext, PatientProps } from '../../contexts/PatientContext';
import { ScheduleItemProps } from '../../models/Schedule';
import { ScheduleContext } from '../../contexts/ScheduleContext';
import ServiceItem from '../../components/ServiceItem';
import { CartContext } from '../../contexts/CartContext';
import { ProductItemProps } from '../../models/Product';

export type PatientScheduleProps = {
  patient: PatientProps;
  schedule: ScheduleItemProps;
  product: ProductItemProps;
  payment: string;
  complete?: boolean;
};

const Configurator = () => {
  const { goTo } = useContextSelector(RouterContext, state => state);
  const { scheduleItems, setSelectedItem } = useContextSelector(ScheduleContext, state => state);
  const { productList } = useContextSelector(CartContext, state => state);
  const { patientSelected } = useContextSelector(PatientContext, state => state);
  const [schedules, setSchedules] = useState<PatientScheduleProps[]>([]);
  const [allowNextPage, setAllowNextPage] = useState(false);

  useEffect(() => {
    const patientSchedules = [] as PatientScheduleProps[];
    let allowNextPage = true;

    if (patientSelected)
      scheduleItems.forEach(schedule => {
        if (schedule.idPatient === patientSelected.idPatient) {
          const patientSchedule = {} as PatientScheduleProps;
          patientSchedule.patient = patientSelected;
          patientSchedule.payment = String(schedule?.payment?.type) || '';
          patientSchedule.schedule = schedule;
          patientSchedule.complete = !!schedule.time && !!schedule?.payment?.type && !!schedule.careType;
          allowNextPage = patientSchedule.complete && allowNextPage;
          const relatedProduct = productList.find(p => p.id === schedule.productId);
          if (relatedProduct) {
            patientSchedule.product = relatedProduct;
          }
          patientSchedules.push(patientSchedule);
        }
      });

    setSchedules(patientSchedules);
    setAllowNextPage(allowNextPage);
  }, [scheduleItems]);

  return (
    <S.Container>
      <S.MainWrapper>
        <HeadTitle title="Agendamento" />
        <S.Subtitle>Escolha um item para agendar</S.Subtitle>
        <ul className="list">
          <S.ListWrapper>
            {schedules.map((patientSchedule, index) => (
              <S.ItemWrapper key={index}>
                {/* <Item
                  product={patientSchedule.product}
                  edit={patientSchedule.complete}
                  onClick={() => {
                    setSelectedItem(patientSchedule.schedule);
                    goTo(PAGES.PAYMENT_VIEW.id);
                  }}
                /> */}
                <ServiceItem
                  disabled={false}
                  product={patientSchedule.product}
                  border={false}
                  whitoutRemoveBtn
                  handleClick={() => {
                    setSelectedItem(patientSchedule.schedule);
                    goTo(PAGES.PAYMENT_VIEW.id);
                  }}
                />
              </S.ItemWrapper>
            ))}
          </S.ListWrapper>
        </ul>
      </S.MainWrapper>
    </S.Container>
  );
};

export default Configurator;
